import { useEffect } from "react";
import { waitAsync } from "@sweatpals/shared";

export const useLottieAnimation = () => {
	useEffect(() => {
		setTimeout(async () => {
			const element = document.getElementById('lottie');
			const svg = element?.getElementsByTagName('svg')?.[0];

			if (svg) {
				svg.style.transition = 'opacity .3s ease-in-out';
				svg.style.opacity = '0';
				await waitAsync(500);
			}

			if (element) {
				element.style.opacity = '0';
				await waitAsync(400);
				element.remove();
			}
		}, 2000);
	});
};
